export const AnalyticsIcon = ({ style }) => (
  <svg viewBox="0 0 24 24" style={style}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3H4ZM7.5 10.5C8.19005 10.5 8.77127 10.034 8.94618 9.39961H11.2524L12.1418 11.1785C12.2096 11.314 12.3481 11.3996 12.4996 11.3996H15.0538C15.2287 12.034 15.81 12.5 16.5 12.5C17.3284 12.5 18 11.8284 18 11C18 10.1716 17.3284 9.5 16.5 9.5C15.8102 9.5 15.2292 9.96557 15.054 10.5996H12.7468L11.8574 8.82072C11.7896 8.68521 11.6511 8.59961 11.4996 8.59961H8.94597C8.77079 7.96557 8.18976 7.5 7.5 7.5C6.67157 7.5 6 8.17157 6 9C6 9.82843 6.67157 10.5 7.5 10.5Z"
      fill="currentColor"
    ></path>
    <path
      d="M7 19.75C7 19.0596 7.55964 18.5 8.25 18.5H15.75C16.4404 18.5 17 19.0596 17 19.75C17 20.4404 16.4404 21 15.75 21H8.25C7.55964 21 7 20.4404 7 19.75Z"
      fill="currentColor"
      fillOpacity="0.4"
      className="path_with_opacity"
    ></path>
  </svg>
);
